/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineAvailableTagListRequest {
    getFixupPrototypeFunction() { return TagBaselineAvailableTagListRequest.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineAvailableTagListRequest>): TagBaselineAvailableTagListRequest {
        let obj = Object.assign(new TagBaselineAvailableTagListRequest(), model);
        TagBaselineAvailableTagListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineAvailableTagListRequest>): TagBaselineAvailableTagListRequest {
        if (!model) return null;
        return TagBaselineAvailableTagListRequest.newInstance(<TagBaselineAvailableTagListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineAvailableTagListRequest) {
        if (!obj) return;

        models.TagBaselineAvailableTagListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineAvailableTagListRequest): boolean {
        Object.setPrototypeOf(obj, TagBaselineAvailableTagListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.TagBaselineAvailableTagFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.TagBaselineAvailableTagSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.TagBaselineAvailableTagSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.TagBaselineAvailableTagFilters;

}
